<template>
    <Tree
        class="t-tree"
        :data="treeList"
        showCheckbox
        @on-check-change="onCheckHouse"
    />
</template>

<script>
import mSelectHouse from '_v/common/m-select-house'
import { marketRoomList } from '@/api/assets'

// Tree房间选择
export default {
    name: 'select-house',
    mixins: [mSelectHouse],
    inject: {
        $modal: { default: null },
    },
    props: {
        // 下架操作
        unPublish: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            treeList: [],
        }
    },
    created() {
        this.$modal.$on('lookup-open', (data) => {
            // 上一次选中项
            this.selectedHouse = data.map((v) => v.option)

            // 打开选择框
            this.$modal.beforeEnter((next) => {
                Promise.all([this.fetch()]).finally(() => {
                    next()
                })
            })

            // 关闭选择框
            this.$modal.onBtnClick('confirm', (next, options) => {
                console.log('selectedHouse', this.selectedHouse[0])
                if (this.selectedHouse.length) {
                    this.$modal.$emit('lookup-close', this.selectedHouse)
                } else {
                    this.$Message.warning('请选择房源')
                    options.closeModal = false
                }

                next()
            })
        })
    },
    methods: {
        fetch() {
            return marketRoomList({
                parkId: this.parkId, // 园区/社区
                floorId: this.floorId, // 楼栋id
                floorNum: this.floorNum, // 楼层
                pageNo: 1,
                pageSize: 9999,
                publishStatus: this.unPublish ? '1' : '0',
            }).then((res) => {
                this.treeList = this.normalizeHouseList(res?.data?.page?.list)
            })
        },
    },
}
</script>

<style></style>
